import { render } from "./IconRepeat.vue?vue&type=template&id=2216700a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconRepeat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2216700a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2216700a', __exports__)) {
    api.reload('2216700a', __exports__)
  }
  
  module.hot.accept("./IconRepeat.vue?vue&type=template&id=2216700a", () => {
    api.rerender('2216700a', render)
  })

}


export default __exports__